import React, { useState, useEffect } from 'react';
import { SignedIn, SignedOut, useAuth } from '@clerk/nextjs';
import Link from 'next/link';
import { getTwitchUrl } from '../lib/api';
import Image from 'next/image';
import StatsBar from './StatsBar';
import HeroBanner from './HeroBanner';

const headingText = "Your AI Clipper";
const words = headingText.split(' ');

const Hero = () => {
  const [showForm, setShowForm] = useState(false);
  const { isSignedIn } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Ensure isVisible is false initially for the animation to trigger correctly
    setIsVisible(false);

    let animationFrameId: number;
    // Set isVisible to true in the next animation frame
    // This allows the browser to process the initial (hidden) state first
    animationFrameId = requestAnimationFrame(() => {
      setIsVisible(true);
    });

    // Cleanup function to cancel the animation frame if the component unmounts
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  const handleTwitchAuth = async () => {
    if (!isSignedIn) {
      window.location.href = '/sign-in?ref=hero';
      return;
    }

    //if the user is signed in, redirect to /bot-setup
    window.location.href = '/bot-setup';
    return;
  };

  return (
    <div className="relative mt-4 mx-6 rounded-2xl overflow-hidden min-h-[calc(80vh)] flex items-stretch justify-center">
      {/* Use next/image for background */}
      <Image
        src="https://storage.googleapis.com/saved_media_assets/landing-background.avif"
        alt="Background"
        layout="fill"
        objectFit="cover"
        quality={100}
        priority
        className="-z-10"
      />
      
      {/* New Bounty Banner - absolutely positioned relative to this parent */}
      <HeroBanner />

      {/* Content container with responsive padding */}
      <div className="relative z-0 flex flex-col items-center text-center w-full px-4 sm:px-6 md:px-8 pt-28 md:pt-36 lg:pt-36 h-full justify-between min-h-[calc(80vh)]">
        {/* Main content wrapper to push stats bar down */}
        <div className="flex flex-col items-center w-full mb-12 flex-grow">
          <div className="flex flex-col items-center text-center">

            
            <h1
              className={`text-4xl sm:text-7xl md:text-8xl lg:text-9xl mb-4 sm:mb-8 md:mb-12 lg:mb-12 leading-tight transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
            >
              <div className="text-white flex flex-wrap justify-center">
                {words.map((word, index) => (
                  <span
                    key={index}
                    className={`inline-block mr-[0.25em] transition-all duration-300 ease-out ${isVisible ? 'opacity-100 translate-y-0 filter blur-none' : 'opacity-0 translate-y-4 filter blur-sm'}`}
                    style={{ transitionDelay: `${index * 50}ms` }}
                  >
                    {word}
                  </span>
                ))}
              </div>
            </h1>
            <p
              className={`text-[#e8e8e8] mb-6 sm:mb-8 md:mb-16 tracking-tight text-sm sm:text-sm md:text-2xl lg:text-2xl max-w-6xl font-thin transition-all duration-300 ease-out ${isVisible ? 'opacity-100 translate-y-0 filter blur-none' : 'opacity-0 translate-y-4 filter blur-sm'}`}
              style={{ transitionDelay: `${(words.length * 50) + 100}ms`}}
            >
              Live highlight detection, editing, auto-upload.
              <br />
              Saved is the all-in-one streaming tool.
            </p>
          </div>

          <div
            className={`flex flex-col sm:flex-row gap-4 items-center justify-center mb-8 sm:mb-12 md:mb-16 w-full max-w-md sm:max-w-lg transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
            style={{ transitionDelay: `${(words.length * 50) + 200}ms` }}
          >
            <button
              onClick={handleTwitchAuth}
              className="w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 bg-black dark:bg-white hover:bg-gray-900 dark:hover:bg-gray-100 text-white dark:text-black rounded-lg transition-all duration-200 text-sm md:text-lg font-bold flex items-center justify-center"
            >
              <svg 
                viewBox="0 0 24 24" 
                className="w-5 h-5 mr-2 fill-current"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
              </svg>
              Add to Chat
            </button>
            <button
              onClick={() => {
                window.location.href = '/creators';
              }}
              className="w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 text-black bg-white dark:bg-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-900 rounded-lg transition-all duration-200 text-sm md:text-lg font-bold"
            >
              Get Paid
            </button>
          </div>
        </div>
        
        <div className="">
          <StatsBar />
        </div>
      </div>
    </div>
  );
};

export default Hero;